export const OAUTH_INTEGRATION_KINDS = ['google-account', 'microsoft-account', 'google-drive', 'microsoft-tenant', 'xero'] as const;

export type OauthIntegrationKind = (typeof OAUTH_INTEGRATION_KINDS)[number];

export const OAUTH_INTEGRATION_LABELS: Record<OauthIntegrationKind, string> = {
  'google-account': 'Google account',
  'microsoft-account': 'Microsoft account',
  'google-drive': 'Google Drive',
  'microsoft-tenant': 'SharePoint',
  xero: 'Xero',
};

export type IntegrationScope = 'member' | 'hub';

export const OAUTH_INTEGRATION_SCOPES: Record<OauthIntegrationKind, IntegrationScope> = {
  'google-account': 'member',
  'microsoft-account': 'member',
  'google-drive': 'hub',
  'microsoft-tenant': 'hub',
  xero: 'hub',
};

export interface IntegrationConnectOffer {
  kind: OauthIntegrationKind;
  label: string;
  scope: IntegrationScope;
}
